import {
  PrimaryRegularButton,
  SecondaryRegularButton
} from 'components/ReusableComponents/Button/RegularButtons'
import {
  PrimarySmallButton,
  SecondarySmallButton
} from 'components/ReusableComponents/Button/SmallButtons'
import PropTypes from 'prop-types'

const Button = ({ size = 'regular', type = 'primary', ...props }) => {
  switch (size) {
    case 'small':
      return type === 'primary' ? (
        <PrimarySmallButton {...props} />
      ) : (
        <SecondarySmallButton {...props} />
      )

    default:
      return type === 'primary' ? (
        <PrimaryRegularButton {...props} />
      ) : (
        <SecondaryRegularButton {...props} />
      )
  }
}

Button.propTypes = {
  size: PropTypes.oneOf(['regular', 'small']),
  type: PropTypes.oneOf(['primary', 'secondary'])
}

export default Button
